const getRecommendProduct = state  => state.product;


export default {
  getRecommendProduct,
};



// WEBPACK FOOTER //
// ./src/store/modules/reserved/recommend/getters.js